<script lang="ts">
  import { onMount } from 'svelte';
  import XIcon from '$icons/XIcon.svelte';
  import DotGrid from './DotGrid.svelte';
  import CornerSquare from './wrappers/CornerSquare.svelte';
  import { browser } from '$app/environment';
  import { fly, fade } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  import { cn } from '$lib/utils/misc';

  export let slideOverOpen: boolean;
  export let title = '';
  export let clickoutCloseDisabled = false;
  export let allowExit = true;
  export let maskBackgroundOnOpen = true;
  export let onClose: (() => void) | null = null;

  function closeSlideOver() {
    slideOverOpen = false;
    onClose?.();
  }

  // Lock page scroll on mount
  onMount(() => {
    if (slideOverOpen) {
      document.body.style.overflow = 'hidden';
    }
  });

  // Lock/unlock page scroll on open state change
  $: if (browser) {
    if (slideOverOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
</script>

{#if slideOverOpen}
  <div class={cn('fixed inset-0 z-40', $$props.class)}>
    <!-- Backdrop -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      transition:fade={{ duration: 150 }}
      class={cn('fixed inset-0', maskBackgroundOnOpen && 'bg-black/80')}
      on:click={() => {
        if (!clickoutCloseDisabled) {
          closeSlideOver();
        }
      }}
    />

    <!-- Sliding Panel -->
    <div
      transition:fly={{ x: '100%', duration: 250, easing: quintOut }}
      class={cn(
        'fixed right-0 top-0 h-full w-full max-w-full sm:w-auto',
        !maskBackgroundOnOpen && 'shadow-[-8px_0_16px_rgba(0,0,0,0.5)]',
      )}
    >
      <CornerSquare class="flex !h-fit w-full flex-col sm:!h-screen sm:w-[520px]">
        <div
          class="gap-x-md border-gray-dark-2 bg-gray-dark-1 !py-md px-lg flex !h-12 !min-h-[48px] w-full items-center overflow-hidden border-b-2"
        >
          <h2
            class="text-normal font-architekt text-gray-dark-12 whitespace-nowrap text-lg leading-6"
          >
            {title}
          </h2>
          <DotGrid />
          {#if allowExit}
            <button on:click={closeSlideOver}>
              <XIcon class="text-gray-dark-11" />
            </button>
          {/if}
        </div>
        <div class="bg-gray-dark-0 px-2xl py-xl relative w-full flex-1 overflow-y-scroll">
          <slot />
        </div>
      </CornerSquare>
    </div>
  </div>
{/if}
